module Omni.Booker {
    var templateUrlFn = function ($templateCache) {
        var navigationTemplate = $templateCache.get("omni-booker-navigation.html");
        if (navigationTemplate) {
            return "omni-booker-navigation.html";
        }

        return "omni/assets/booker/booker.defaultnav.html";
    }
    templateUrlFn.$inject = ["$templateCache"];

    NgModule.component("omniBookerNavigation", {
        controller: class OmniBookerNavController {
            static scrollDuration = 0;
            ShowBooker: boolean;
            Expanded: boolean;
            BrandPage: boolean;

            static $inject = [
                "$rootScope",
                "$scope",
                "$document",
                "$window",
                "omni.bookingservice"
            ];
            constructor(
                private readonly $rootScope,
                private readonly $scope,
                private readonly $document,
                private readonly $window,
                private readonly bookingService: IBookingService
            ) {
                this.onBookerStateUpdate();
                this.$scope.$on("bookerStateUpdate", () => { this.onBookerStateUpdate(); });
            }

            ToggleNavigation() {
                if (this.isBookerVisible()) {
                    this.bookingService.ToggleBooker();
                } else {
                    this.bookingService.OpenBooker();
                }
            }

            private isBookerVisible(): boolean {
                const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

                if (this.$document.scrollTop() < h / 2) {
                    return true;
                }

                return false;
            }

            private scrollToTop() {
                const left = 0, top = 0, duration = OmniBookerNavController.scrollDuration;
                // Scroll to the exact position
                this.$document.duScrollTo(left, top, duration);
            }

            private onBookerStateUpdate() {
                const bookerState = this.bookingService.GetBookerState();
                this.ShowBooker = bookerState.IsEnabled;
                this.Expanded = bookerState.IsExpanded;
                this.BrandPage = bookerState.IsBrandPage;

                if (this.Expanded) {
                    this.scrollToTop();
                }
            }
        },
        templateUrl: templateUrlFn
    });
}